var PaymentMode;
(function (PaymentMode) {
    PaymentMode["cash"] = "cash";
    PaymentMode["prepaid"] = "prepaid";
    PaymentMode["payment_gateway"] = "payment_gateway";
    PaymentMode["card_on_delivery"] = "card_on_delivery";
})(PaymentMode || (PaymentMode = {}));

export { PaymentMode };
//# sourceMappingURL=web.interface.js.map
